module.exports = __webpack_public_path__ + "img/loan_inner0.5.48accac6.png";